var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"general-article-container"},[_c('article',{ref:"introContainer"},[_c('div',{ref:"introMainContainer",staticClass:"article article-main-pal",domProps:{"innerHTML":_vm._s(_vm.processHtml(_vm.articleContent))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }